/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum KYCWorkflowStatus {
    OPEN = 'OPEN',
    DEFINITION_COMPLETE = 'DEFINITION_COMPLETE',
    IN_PROGRESS = 'IN_PROGRESS',
    APPROVED = 'APPROVED',
    WITHDRAWN = 'WITHDRAWN',
}
